import * as zod from 'zod';

import { SpeedProfile } from '../speed-profile';

export const PlayRoutineArgs = zod.object({
  /**
   * Run the first arm movement in guided mode, then switch guided mode off
   */
  firstArmMoveIsGuidedMode: zod.boolean().optional(),
  /**
   * Run the main loop through once, then pause on `routineCompleted` so the
   * operator can inspect the result and resume the same run at full speed.
   * Every other run stops when it completes.
   */
  isPreflightTestRun: zod.boolean().optional(),
  speedProfile: SpeedProfile,
  /**
   * If true, starts the routine execution in background and returns immediately (fire and forget)
   */
  fireAndForget: zod.boolean().optional(),
});

export type PlayRoutineArgs = zod.infer<typeof PlayRoutineArgs>;
